export default __webpack_public_path__ + "static/media/mheader-min.f75dc019.jpg";